// Pulse is only on when both flags are set; every Pulse surface checks the pair.
export const PULSE_FEATURE_FLAGS = ['pkg.ai.bizai_pulse', 'rollout.ai.bizai_pulse'];

export const isPulseEnabled = (hasFeature) => PULSE_FEATURE_FLAGS.every((flag) => hasFeature(flag));

// Pulse lives on `/home` on desktop (pulse/routes.js). The classic sidebar names that item
// `home` in menuItems.json; the platform sidebar is API-driven, so it is only recognisable
// by its path, which arrives either as `/app/home` or `/home`.
const PULSE_MENU_ITEM_NAME = 'home';
const PULSE_MENU_ITEM_PATH = '/home';

const normalizeMenuItemPath = (path) => (typeof path === 'string'
  ? path.replace(/^\/app(?=\/|$)/, '').split('?')[0].replace(/\/$/, '')
  : '');

export const isPulseMenuItem = (item) => {
  if (!item) return false;
  const path = normalizeMenuItemPath(item.url_path || item.url);
  if (path) return path === PULSE_MENU_ITEM_PATH;
  return item.name === PULSE_MENU_ITEM_NAME;
};
